import { DownOutlined, GlobalOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { getLocale, setLocale } from '@umijs/max';
import { Button, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { normalizeAppLocale, type AppLocale } from '@/utils/i18n';

const SUPPORTED_LANGUAGE_LABELS: Record<string, string> = {
  'zh-CN': '简体中文',
  'en-US': 'English',
};

export type SiderTheme = 'light' | 'dark';

export const SelectLang: React.FC = () => {
  const currentLocale = normalizeAppLocale(getLocale());

  const items: MenuProps['items'] = (Object.entries(SUPPORTED_LANGUAGE_LABELS) as Array<[AppLocale, string]>).map(
    ([lang, label]) => ({
      key: lang,
      label,
    }),
  );

  const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
    const nextLocale = normalizeAppLocale(String(key));
    if (nextLocale !== currentLocale) {
      setLocale(nextLocale, false);
    }
  };

  return (
    <Dropdown menu={{ items, onClick: handleMenuClick, selectedKeys: [currentLocale] }} trigger={['click']}>
      <Button
        type="text"
        icon={<GlobalOutlined />}
        style={{ paddingInline: 8 }}
      >
        {SUPPORTED_LANGUAGE_LABELS[currentLocale]}
        <DownOutlined style={{ fontSize: 10, marginInlineStart: 6 }} />
      </Button>
    </Dropdown>
  );
};

export const Question: React.FC = () => {
  return (
    <a
      href="https://pro.ant.design/docs/getting-started"
      target="_blank"
      rel="noreferrer"
      style={{
        display: 'inline-flex',
        padding: '4px',
        fontSize: '18px',
        color: 'inherit',
      }}
    >
      <QuestionCircleOutlined />
    </a>
  );
};
